import { observer } from 'mobx-react';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useDependencies } from '@servicetitan/react-ioc';
import { Icon, Stack } from '@servicetitan/design-system';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { Routes } from '../../enums/routes';
import { ProfileDropdown } from './profile-dropdown';
import { SettingsMenuDropdown } from './settings-dropdown';
import { PartitionsDropdown } from './partitions-dropdown';
import { isValidUrl } from '../../utils/url-helpers';

import * as Styles from './header.module.less';

const logo = require('../../../../assets/logo.svg');

export const Header: FC = observer(() => {
    const [{ tenant, tenantConfigs }] = useDependencies(StandaloneRootStore);
    const helpUrl = tenantConfigs['PartnerKB:Url'];

    const menu = tenant && (
        <Stack direction="row" wrap="nowrap" alignItems="center" spacing={2}>
            {isValidUrl(helpUrl) && (
                <a href={helpUrl} rel="noopener noreferrer" target="_blank">
                    <Icon name="help_outline" size={24} className={Styles.navItem} />
                </a>
            )}
            <SettingsMenuDropdown />
            <PartitionsDropdown />
            <ProfileDropdown user={tenant.name} />
        </Stack>
    );

    return (
        <Stack className={Styles.header} justifyContent="space-between" alignItems="center">
            <Link to={Routes.Home}>
                <img src={logo} alt="ServiceTitan Marketing Pro Logo" />
            </Link>
            {menu}
        </Stack>
    );
});
